module.exports = __webpack_public_path__ + "static/media/Info.f3460aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/product-step/scrapping/Info.png
// module id = 1646
// module chunks = 0